import Immutable from 'immutable';
import PropTypes from 'prop-types';
export default class SearchParamsUpdate extends Immutable.Record({
  /**
   * Set[FacetType]
   */
  types: undefined,

  /**
   * params => params
   */
  apply: undefined
}) {
  compose(spu2) {
    return new SearchParamsUpdate({
      types: this.types.concat(spu2.types),
      apply: params => spu2.apply(this.apply(params))
    });
  }

  copy({
    types,
    apply
  }) {
    return new SearchParamsUpdate({
      types: types || this.types,
      apply: apply || this.apply
    });
  }
  /**
   * @param f : params => params
   * @return {SearchParamsUpdate}
   */


  composeApply(f) {
    return new SearchParamsUpdate({
      types: this.types,
      apply: params => f(this.apply(params))
    });
  }

  static default_() {
    return new SearchParamsUpdate({
      types: Immutable.Set(),
      apply: q => q
    });
  }

}
export const SearchParamsUpdatePropType = PropTypes.instanceOf(SearchParamsUpdate);